import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntroWizardComponent } from './intro-wizard.component';
import {Routes, RouterModule} from '@angular/router';
import {IllustrationComponent} from './illustration/illustration.component';
import {SharedModule} from '../shared/shared.module';
import {StartComponent} from './start/start.component';

const routes: Routes = [
  {
    path: '',
    component: IntroWizardComponent,
    children: [
      { path: '', component: IllustrationComponent},
      { path: 'start', component: StartComponent}
      ]
  }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule
  ],
  declarations: [IntroWizardComponent, IllustrationComponent, StartComponent],
  providers: []
})
export class IntroWizardModule { }



// WEBPACK FOOTER //
// ./src/app/intro-wizard/intro-wizard.module.ts